<script lang="ts">
  import type { Choice } from "./types";
  import FooterButtons from "../../components/workflow/FooterButtons.svelte";
  import CloseButton from "../../components/CloseButton.svelte";
  import ContinueButton from "../../components/workflow/ContinueButton.svelte";

  let {
    choice = $bindable(),
    detailsToVerify,
    errors
  }: {
    choice: Choice;
    detailsToVerify: string;
    errors: { [key: string]: string } | undefined;
  } = $props();

  let options = $derived([
    {value: "upload", label: "Upload easyJet booking confirmation", badge: "Recommended"},
    {value: "details", label: `Enter the ${detailsToVerify} you booked with`},
  ]);
</script>

<h2 class="ui-title">Respond to easyJet</h2>

<p>easyJet cannot identify your booking with the current details we hold.</p>

<p>To proceed with your claim, we need to confirm your booking details or your {detailsToVerify} at the time of booking.</p>

<fieldset class="ui-fieldset">
  <legend class="mb-2">Choose one of the options below:</legend>
  {#snippet option({name, value, label, badge = ""}: {name: string, value: string, label: string, badge?: string})}
    <div class="ui-option-container relative">
      {#if badge}
        <div class="absolute -top-3 text-sm font-medium text-emerald-700 bg-emerald-100 py-[0.1250rem] px-2 rounded-badge">{badge}</div>
      {/if}
      <label class={["flex flex-row gap-2 items-start", badge && "mt-3"]}>
        <input type="radio" class="radio" {name} {value} bind:group={choice} required>
        {label}
      </label>
    </div>
  {/snippet}
  {#each options as optionData}{@render option({ name: "choice", ...optionData})}{/each}
</fieldset>

{#if errors?.general}<div class="ui-error">{errors.general}</div>{/if}

<FooterButtons back={false}>
  <CloseButton label="Cancel" />
  <ContinueButton type="button" />
</FooterButtons>
